import React from "react";
import { Slider } from "antd";
import type { SliderSingleProps, SliderRangeProps } from "antd/es/slider"; // Import specific prop types
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

// Define props based on Ant Design's exported types
type BaseSliderProps = Omit<SliderSingleProps, 'range'> | Omit<SliderRangeProps, 'range'>;

// Use intersection type for the props
type TrebbleSliderProps = BaseSliderProps & {
  range?: boolean | 'draggableTrack'; // Re-add range explicitly if needed by the union logic
  useEditorTheme?: boolean;
};

const TrebbleSlider = ({ useEditorTheme, ...restProps }: TrebbleSliderProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      {/* Cast props if necessary, or rely on Ant Design's internal handling */}
      <Slider {...restProps as any} /> 
    </TrebbleConfigProvider>
  );
};

export default TrebbleSlider; 